import { render } from "./WalletBreakdownByExchange.vue?vue&type=template&id=20044e59&scoped=true"
import script from "./WalletBreakdownByExchange.vue?vue&type=script&lang=js"
export * from "./WalletBreakdownByExchange.vue?vue&type=script&lang=js"

import "./WalletBreakdownByExchange.vue?vue&type=style&index=0&id=20044e59&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20044e59"]])

export default __exports__